import React, { createContext, useContext, useEffect, useState } from "react";
import ApiService from "../components/Services/ApiServices";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const refreshAuth = async () => {
    try {
      await ApiService.post("/auth/refresh");
      const res = await ApiService.get("/auth/me");

      if (res?.status) {
        setUser(res.data || true);
        return true;
      }

      setUser(null);
      return false;
    } catch (err) {
      setUser(null);
      return false;
    } finally {
      setAuthLoading(false);
    }
  };

  const logout = async () => {
    try {
      await ApiService.post("/auth/logout");
    } catch (e) {}
    setUser(null);
    window.location.href = "/login";
  };

  useEffect(() => {
    refreshAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        authLoading,
        refreshAuth,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);